import React from 'react'
import {ThemeProvider} from 'styled-components'
import {GlobalStyle} from '@miro-site/core'

import theme from './theme'

const TemplatesThemeProvider: React.FC<{children: React.ReactNode}> = ({children}) => {
  return (
    <ThemeProvider theme={defaultTheme => ({...defaultTheme, ...theme})}>
      <GlobalStyle />
      {children}
    </ThemeProvider>
  )
}

export default TemplatesThemeProvider
